module.exports = __webpack_public_path__ + "img/40_37_026_620.a630eafa.jpg";